import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MenuStructureSection} from '../components/public-page/main-menu/menu-structure-edit-dialog/model/menu-section';
import {SectionModeratorInfo} from "../components/moderators-admin/model/section-moderator-info";

@Injectable()
export class MainMenuStructureService {

  constructor(private _http: HttpClient) {
  }

  getMenuSections() {
    return this._http.get<any>('api/a/main/menu/structure/all/list/');
  }

  saveMenuSection(section: MenuStructureSection, isSubSection) {
    return this._http.post<any>(`api/a/main/menu/structure/${isSubSection ? 'subSection' : 'section'}/save`, section);
  }

  deleteMenuSection(section: MenuStructureSection, isSubSection) {
    return this._http
      .delete<any>(`api/a/main/menu/structure/${isSubSection ? 'subSection' : 'section'}/delete/${section.id}`);
  }

  getUniversityInfoSettings() {
    return this._http.get<any>('api/a/universityInfo/access/get');
  }

  saveUniversityInfoSettings(settings: Map<String, boolean>) {
    return this._http.post<any>('api/a/universityInfo/access/update', settings);
  }

  saveModeratorsList(params: SectionModeratorInfo[]) {
    return this._http.post<SectionModeratorInfo[]>('api/a/main/menu/structure/moderators/save', params);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/services/main-menu-structure.service.ts